const toggletipExplainer = "_toggletipExplainer_l53j5_3";
const toggletipButton = "_toggletipButton_l53j5_9";
const toggletipTrigger = "_toggletipTrigger_l53j5_29";
const toggletipIcon = "_toggletipIcon_l53j5_45";
const toggletipTriggerIconHidden = "_toggletipTriggerIconHidden_l53j5_50";
const toggletipPopover = "_toggletipPopover_l53j5_56";
const toggletipArrow = "_toggletipArrow_l53j5_69";
const styles = {
  toggletipExplainer,
  toggletipButton,
  toggletipTrigger,
  toggletipIcon,
  toggletipTriggerIconHidden,
  toggletipPopover,
  toggletipArrow,
  "toggletip-default-icon": "_toggletip-default-icon_l53j5_75",
  "toggletip-default-active": "_toggletip-default-active_l53j5_83",
  "toggletip-default-text": "_toggletip-default-text_l53j5_91",
  "toggletip-inverted-icon": "_toggletip-inverted-icon_l53j5_97",
  "toggletip-inverted-active": "_toggletip-inverted-active_l53j5_105",
  "toggletip-inverted-text": "_toggletip-inverted-text_l53j5_113"
};
export {
  styles as s
};
